import './OfferAndDealSearch.css';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SearchIcon } from "../../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../../resources/icons/close.svg";
import { canUseDOM } from '../../../utils';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { HighlighterHOC } from '../../atoms/HighlighterHOC/HighlighterHOC';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { TEXT_SEARCH_FACET_NAME } from '../constants';
const commonStyles = "ckqtnfu";
const ltrStyles = "l1xgcaiy";
const rtlStyles = "r1613089";
const SuggestionsList = _ref => {
  let {
    suggestionList,
    resultsTitle,
    resultsForText,
    searchString,
    requestedString,
    sendRequestHandler,
    resultsNumber,
    eventsAnalytics,
    params
  } = _ref;
  const drop = useRef(null);
  const list = useRef(null);
  const [scrollable, setScrollable] = React.useState(false);
  const handleItemClick = title => {
    sendRequestHandler(title);
  };
  const resultsString = useMemo(() => {
    if (requestedString) {
      const splitted = resultsForText.replace('{N}', resultsNumber).split('{S}');
      const result = /*#__PURE__*/React.createElement(React.Fragment, null, splitted[0], /*#__PURE__*/React.createElement("span", {
        className: "suggestions-list-total__string"
      }, requestedString), splitted[1]);
      return result;
    }
    return null;
  }, [resultsForText, resultsNumber, requestedString]);
  useEffect(() => {
    if (list.current && list.current.offsetHeight > 300) {
      setScrollable(true);
    } else {
      setScrollable(false);
    }
  }, [suggestionList]);
  return /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-wrapper",
    ref: drop
  }, /*#__PURE__*/React.createElement("div", {
    className: " row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 col-xl-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-block"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "suggestions-list-header"
  }, resultsTitle), /*#__PURE__*/React.createElement("div", {
    className: clsx('suggestions-list-shadows', {
      'suggestions-list-shadows--active': scrollable
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-scroll-scrollable"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list autocomplete ",
    ref: list
  }, suggestionList.map(suggestion => {
    return /*#__PURE__*/React.createElement("li", {
      className: "suggestion-item",
      key: suggestion,
      onClick: () => {
        handleItemClick(suggestion);
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['suggestedSearchAnalytics'], params), suggestion);
      }
    }, /*#__PURE__*/React.createElement(HighlighterHOC, {
      text: suggestion,
      searchString: searchString
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-total"
  }, resultsString)))));
};
const OfferAndDealSearch = _ref2 => {
  let {
    rtl,
    searchValue,
    setSearchValue,
    placeholder,
    resultsTitle,
    resultsForText,
    setListingFilter,
    mostSearchedValues,
    resultsNumber,
    eventsAnalytics,
    params
  } = _ref2;
  let history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [highLightText, setHighLightText] = useState(false);
  const [value, setValue] = useState(searchValue);
  const clickedTextRef = useRef(false);
  const fieldOpenedRef = useRef(null);
  const handleTextBlur = () => {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  const handleTextMousedown = () => {
    clickedTextRef.current = true;
  };
  const handleTextFocus = () => {
    setIsOpen(true);
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  const handleTextInput = e => {
    setIsOpen(true);
    const target = e.target;
    setValue(target.value);
  };
  const handleCloseClick = () => {
    setValue('');
    if (searchValue) {
      setSearchValue('');
      deleteQueryString(TEXT_SEARCH_FACET_NAME, history);
      setListingFilter();
    }
  };
  const handleKeyPress = event => {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim() !== searchValue.trim()) {
      sendRequestHandler(value);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchButtonAnalytics'], params), value);
    }
  };
  const handleGoClick = () => {
    sendRequestHandler(value);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchButtonAnalytics'], params), value);
  };
  const sendRequestHandler = title => {
    setIsOpen(false);
    setValue(title);
    setSearchValue(title);
    addQueryString(TEXT_SEARCH_FACET_NAME, title, history);
    setListingFilter();
  };
  const hideDD = e => {
    if (fieldOpenedRef.current) {
      const mobileDevice = window.matchMedia(`(max-width: 991px)`).matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest('.input-search-box') || e.target.closest('.suggestions-list-block')) return;
      }
      setIsOpen(false);
    }
  };
  useEffect(() => {
    fieldOpenedRef.current = isOpen;
  }, [isOpen]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: mostSearchedValues,
    resultsTitle: resultsTitle,
    resultsForText: resultsForText,
    searchString: value,
    requestedString: searchValue,
    sendRequestHandler: sendRequestHandler,
    resultsNumber: resultsNumber,
    eventsAnalytics: eventsAnalytics,
    params: params
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: clsx('input-search-text', {
      'input-text-primary--focused': highLightText,
      'input-search-text--opened-drop': isOpen
    }),
    placeholder: placeholder,
    onClick: () => setIsOpen(true),
    onKeyPress: handleKeyPress,
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    "aria-label": placeholder || 'Search for deals across Dubai',
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null))));
};
export default OfferAndDealSearch;